import React, { useRef } from 'react';
import Header from './Header';
import Footer from './Footer';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const Layout = ({ children }) => {
  const location = useLocation();
  const nodeRef = useRef(null);
  
  return (
    <Box className="App">
      <Header />
      <Box 
        component="main" 
        className="main-content"
        sx={{
          minHeight: { lg: '70vh' } // Ensure minimum height on desktop
        }}
      >
        <TransitionGroup>
          <CSSTransition 
            key={location.key} 
            classNames="page-transition" 
            timeout={300}
            nodeRef={nodeRef}
          >
            <div ref={nodeRef}>
              {children}
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;